require([
    'services',
    'jquery',
    'semantic',
    'ch_semantic_wishlist',
    'ch_email_wishlist',
    'ch_header',
    'ch_scrollto',
    'ch_semantic_responsive',
    'ch_section_interest'
], function () {
    function initSemanticWishlistPage() {
        var userWishlistCount = $('#user-wishlist-count');
        var ModalWindowShareWishListObj = new ModalWindowShareWishList();
        var $courseRecommendationsSection = $('#wishlist-rec-section');

        $courseRecommendationsSection.hide();

        $('#share-wishlist').click(function(e) {
            e.preventDefault();
            ModalWindowShareWishListObj.show()
        });

        $('.scroll-action').unbind('click').on('click', function(e) {
            e.preventDefault();
            var type = $(this).attr('type');

            switch (type) {
                case 'recommendations':
                    CH.scrollToElement($courseRecommendationsSection);
                    break;
                default:
                    break;
            }
        });

        $.ajax({
            type: 'GET',
            url: '/user/wishlist/get-wishlist-course-recommendation',
            dataType: 'html',
            success: function (html) {
                $courseRecommendationsSection
                    .empty()
                    .append(html)
                    .fadeIn();
                CH.initSemanticWishlist();
            },
        });

        $('.js-learn-more-non-enrollment').on('click', function() {
            $self = $(this);
            $wishlistCard = $self.parent().parent();
            var sectionId = $(this).attr('data-section-id');
            var courseName = $wishlistCard.find('.js-course-name').html();
            var providerName = $wishlistCard.find('.js-provider-name').html();

            CH.showSectionInterestModal(
                sectionId,
                courseName,
                providerName
            );
        });

        $('.wishlist-page-saved-course').click(function (e) {
            e.preventDefault();

            // Local scope variables
            var $self = $(this);
            var $courseCard = $self.closest('.card');
            var courseId = $self.attr('data-course-id');

            if (!courseId) {
                return;
            }

            swal({
                title: 'Please Confirm',
                text: 'Are you sure you want to remove this class from your wishlist?',
                type: 'warning',
                showCancelButton: true
            }, function() {
                // immediately behave like it succeeded
                $courseCard.fadeOut('slow');
                userWishlistCount.html(parseInt(userWishlistCount.innerHTML) - 1);

                $.post(
                    '/user/wishlist/remove-from-wishlist',
                    { course_id: courseId },
                    function(res) {
                        if (!res.success && res.error) {
                            new ModalMessage({
                                message: res.error,
                                callback: function() {
                                    window.location.reload();
                                }
                            });
                        }

                        ga('send', 'event', 'Wishlist', 'Remove', window.location.pathname + ' ' + res.course.name, {
                            nonInteraction: false
                        });

                        window.location =  "https://" + window.location.host + window.location.pathname;
                    }
                );
            });
        });
    }

    $(function() {
        initSemanticWishlistPage();
    });
});
